<template>
  <Modal
    v-model="dialogVisible"
    :title="$t('资金划转')"
    :closable="false"
    :mask-closable="false"
    width="758px;"
    class-name="transfer-modal"
  >
    <!-- class="transfer-modal" -->
    <div>
      <div class="warning-box">
        <img :src="require('@/assets/images/warning1.png')" />
        <span>
          <!-- 当您持有合约仓位时，为了避免划转合约账户资产后致保证金不足触发强平机制，系统会限制划转数量不得高于可划转数量的50%。 -->
          {{
            $t(
              '当您持有合约仓位时，为了避免划转合约账户资产后致保证金不足触发强平机制，系统会限制划转数量不得高于可划转数量的50%。'
            )
          }}
        </span>
      </div>

      <div class="form-box">
        <div class="form-item">
          <div class="form-item--label">{{ $t('选择币种：') }}</div>
          <div class="form-item--content currency-box">
            <div
              v-for="item in holdingData"
              :key="item.currency"
              class="currency-item"
              :class="{ active: item.currencyName === checkedCurrency }"
              @click=";(checkedCurrency = item.currencyName), (ammount = '')"
            >
              {{ item.currencyName }}
            </div>
          </div>
        </div>
        <div class="form-item">
          <div class="form-item--label">{{ $t('从：') }}</div>
          <div class="form-item--content">
            {{ $t(walletConfig.fromWallet) }}
          </div>
        </div>
        <div class="form-item">
          <div class="form-item--label"></div>
          <div class="form-item--content transfer-img">
            <img
              :src="require('@/assets/images/transfer.png')"
              @click=";(direction = direction ^ 1), (ammount = '')"
            />
          </div>
        </div>
        <div class="form-item">
          <div class="form-item--label">{{ $t('划转至：') }}</div>
          <div class="form-item--content to-wallet">
            {{ $t(walletConfig.toWallet) }}
          </div>
        </div>
        <div class="form-item">
          <div class="form-item--label">{{ $t('选择币种：') }}</div>
          <div class="form-item--content">
            <div class="ammount-box">
              <div class="input-box">
                <input
                  v-model="ammount"
                  :placeholder="$t('请输入数量')"
                  @input="handleInput(ammount, 'ammount', ammountDigit)"
                  @blur="ammount = +ammount ? `${+ammount}` : ''"
                />
                <span>{{ checkedCurrency }}</span>
              </div>
              <div class="available-box">
                <span>
                  {{ $t('可划转数量：') }}
                </span>
                <span>
                  {{ availableAmmount }}
                </span>
                <span
                  @click="
                    handleInput(
                      +availableAmmount ? `${+availableAmmount}` : '',
                      'ammount',
                      ammountDigit
                    )
                  "
                >
                  {{ $t('全部') }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <span slot="footer">
      <Button type="text" @click="dialogVisible = false">
        {{ $t('取消') }}
      </Button>
      <Button type="primary" :loading="loading" @click="commitTransferEvent">
        {{ $t('确认') }}
      </Button>
    </span>
  </Modal>
</template>

<script>
import digitalProcess from '@/mixin/digital-process'
import { doTransfer } from '@/api/transaction'
import { Big } from 'big.js'

export default {
  mixins: [digitalProcess],
  props: {
    value: Boolean,
    holdingData: Array,
    initCurrency: String,
    coinsAsset: Array,
  },
  data() {
    return {
      loading: false,
      checkedCurrency: this.initCurrency,
      direction: 1, //  0 币币->合约 1 合约->币币
      ammount: '',
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.value
      },
      set(val) {
        this.ammount = ''
        this.$emit('input', val)
      },
    },
    contractAvailableAmmount() {
      if (!this.holdingData.length) return '--'
      const currency = this.holdingData.find(
        (item) => item.currencyName === this.checkedCurrency
      )
      return currency?.available || '0'
    },
    currencyInfo() {
      return this.coinsAsset.find(
        (item) => item.coinName === this.checkedCurrency
      )
    },
    coinsAvailableAmmount() {
      if (!this.coinsAsset.length) return '--'
      return this.currencyInfo?.amountUsable || '0'
    },
    // 数量精度
    ammountDigit() {
      return this.currencyInfo?.showDigits || 4
    },
    availableAmmount() {
      return this.direction
        ? this.contractAvailableAmmount
        : this.coinsAvailableAmmount
    },
    walletConfig() {
      const wallets = ['币币钱包', '合约钱包']
      return {
        fromWallet: wallets[this.direction],
        toWallet: wallets[this.direction ^ 1],
      }
    },
  },
  watch: {
    initCurrency(newV) {
      this.checkedCurrency = newV
    },
  },
  methods: {
    async commitTransferEvent() {
      if (!+this.ammount) {
        return this.$Message.warning(this.$t('请输入币种数量'))
      }
      if (Big(this.ammount).gt(this.availableAmmount)) {
        return this.$Message.warning(this.$t('余额不足'))
      }
      try {
        this.loading = true
        await doTransfer({
          coinCode: this.checkedCurrency,
          num: this.ammount,
          type: this.direction,
        })

        this.$Message.success(this.$t('操作成功'))
        this.$emit('transferSucceed')

        this.dialogVisible = false
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
